import { getApiKey, loginGql } from "@/core/constant/apiQuery"
import { ethers, providers } from "ethers"
import { setCookie } from "@/core/utils/cookieUtils"
import { getPRCErrorMessage } from "@/core/utils/getPRCErrorMessage"
import { ApolloClient } from "@apollo/client/core"
import { MessageState } from "@/core/store/AlertContainer"

export function handleLoginConnector(
  client: ApolloClient<object>,
  address: string,
  pushAlert: (newState: MessageState) => void,
  catchAction?: () => void
): Promise<{ sign: string, nonce: string }> {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: getApiKey,
        variables: { address },
        context: {
          headers: { "x-api-key": "da2-zcx56y7bjbg7boiih3bbailrmm" },
        },
      })
      .then(async res => {
        const nonce = res.data.getNonce.NONCE
        const provider = window.diverWallet || window.ethereum
        if (window && provider) {
          const web3provider = new ethers.providers.Web3Provider(
            provider as providers.ExternalProvider,
            "any"
          )
          const sign = await web3provider
            .getSigner()
            .signMessage(`I am signing with nonce: ${nonce}`)

          client
            .query({
              query: loginGql,
              variables: { address, sign },
              context: {
                headers: { "x-api-key": "da2-zcx56y7bjbg7boiih3bbailrmm" },
              },
            })
            .then(res => {
              const deadline = 60 * 60 * 3 // 3 hours
              setCookie("jwt-token", res.data.login.token, deadline)
              // location.reload()
              resolve({ sign, nonce })
            })
            .catch(err => {
              catchAction && catchAction()
              pushAlert({
                message: err.reason || err.message || JSON.stringify(err),
                severity: "error",
              })
              reject(err)
            })
        }
      })
      .catch(err => {
        catchAction && catchAction()
        if (err.code) {
          pushAlert({
            message: getPRCErrorMessage(err),
            severity: "error",
          })
        } else {
          pushAlert({
            message: err.reason || err.message || JSON.stringify(err),
            severity: "error",
          })
        }
        reject(err)
      })
  })
}
